


















import { Component, Vue } from "vue-property-decorator";
import AuditTabPane from "../components/AuditTabPane.vue";
import api from "@/api";
// import {AuditUserLogType} from "@/api/appService";

@Component({
  name: "AuditTabOfExternalMonthlySummarize",
  components: { AuditTabPane },
})
export default class AuditTabOfExternalMonthlySummarize extends Vue {
  get fetchData() {
    return api.externalMonthlySummarize.getMyAll;
  }

  handleAudit(dto: any) {
    return this.$router.push({
      name: "externalMonthlySummarizeDetail",
      params: {
        id: dto.id,
      },
    });
  }

  handleCountChange(value: number) {
    this.$emit("count-changed", value);
  }
}
